var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconShoppingCartCircle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 28,
    height: 28,
    rx: 14,
    fill: "#CCCFD1"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.39576 12H19.486L19.848 10.5714H10.8436V9.14286H20.7761C20.8861 9.14286 20.9947 9.16762 21.0936 9.21524C21.1925 9.26287 21.2791 9.33211 21.3468 9.4177C21.4145 9.5033 21.4615 9.603 21.4843 9.70922C21.5071 9.81544 21.505 9.92539 21.4783 10.0307L19.6685 17.1736C19.6292 17.328 19.5388 17.4651 19.4116 17.5631C19.2844 17.6611 19.1276 17.7143 18.9662 17.7143H8.67182C8.47982 17.7143 8.29568 17.639 8.15992 17.5051C8.02415 17.3711 7.94788 17.1894 7.94788 17V8.42857H6.5V7H8.67182C8.86382 7 9.04795 7.07525 9.18372 7.20921C9.31948 7.34316 9.39576 7.52485 9.39576 7.71429V12ZM9.39576 22C9.01176 22 8.64348 21.8495 8.37195 21.5816C8.10042 21.3137 7.94788 20.9503 7.94788 20.5714C7.94788 20.1925 8.10042 19.8292 8.37195 19.5613C8.64348 19.2934 9.01176 19.1429 9.39576 19.1429C9.77976 19.1429 10.148 19.2934 10.4196 19.5613C10.6911 19.8292 10.8436 20.1925 10.8436 20.5714C10.8436 20.9503 10.6911 21.3137 10.4196 21.5816C10.148 21.8495 9.77976 22 9.39576 22ZM18.083 22C17.699 22 17.3308 21.8495 17.0592 21.5816C16.7877 21.3137 16.6351 20.9503 16.6351 20.5714C16.6351 20.1925 16.7877 19.8292 17.0592 19.5613C17.3308 19.2934 17.699 19.1429 18.083 19.1429C18.467 19.1429 18.8353 19.2934 19.1068 19.5613C19.3784 19.8292 19.5309 20.1925 19.5309 20.5714C19.5309 20.9503 19.3784 21.3137 19.1068 21.5816C18.8353 21.8495 18.467 22 18.083 22Z",
    fill: "#181818"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconShoppingCartCircle);
export default __webpack_public_path__ + "static/media/icon-shopping-cart-circle.f93491f20386f5158ab0eb9e0cb193a6.svg";
export { ForwardRef as ReactComponent };